import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProjectIntakeRoutingModule } from './project-intake-routing.module';
import { AddprojectComponent } from './components/addproject/addproject.component';
import { GinfoKeyDatesComponent } from './components/projects/ginfo-key-dates/ginfo-key-dates.component';
import { GinfoObjectiveGoalsComponent } from './components/projects/ginfo-objective-goals/ginfo-objective-goals.component';
import { CommonStoreListComponent } from './components/common/common-store-list/common-store-list.component';
import { GinfoProjectDetailsComponent } from './components/projects/ginfo-project-details/ginfo-project-details.component';
import { CommonProductsListComponent } from './components/common/common-products-list/common-products-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AddEditSalesPlanComponent } from './components/salesplan/addeditsalesplan/addeditsalesplan.component';
import { GeneralInfoSalesplanDetailsComponent } from './components/salesplan/ginfo-salesplan-details/ginfo-salesplan-details.component';
import { GinfoSpKeyDatesComponent } from './components/salesplan/ginfo-salesplan-keydates/ginfo-salesplan-keydates.component';
import { ImageuploadComponent } from './components/salesplan/image-upload/imageupload.component';
import { CalendarModule } from 'primeng/calendar';
import { RouterModule } from '@angular/router';
import { CommonProductListManualComponent } from './components/common/common-product-list-manual/common-product-list-manual.component';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProjectCostEstimatesComponent } from './components/projects/project-cost-estimates/project-cost-estimates.component';
import { SharedModule } from '../shared/shared.module';
import { CommonApprovalComponent } from './components/common-approval/common-approval.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FundingRmsComponent } from './components/projects/funding-rms/funding-rms.component';
import { InstructionsComponent } from './components/projects/instructions/instructions.component';
import { CurrencyFormatPipe } from '../currency-format.pipe';
import { CheckIsValueEmptyPipePipe } from './pipes/check-is-value-empty-pipe.pipe';
import { MessageService } from './services/message.service';
import { NgxEditorModule } from 'ngx-editor';
import { GetApprovalStageColorPipe } from './pipes/get-approval-stage-color.pipe';
import { AgencyQuestionsComponent } from './components/projects/agency-questions/agency-questions.component';
import { SreValidationCriteriaComponent } from './components/projects/sre-validation-criteria/sre-validation-criteria.component';
import { EditorModule } from 'primeng/editor';
import { DialogModule } from 'primeng/dialog';
import { AddEditAdhocComponent } from './components/adhoc/add-edit-adhoc/add-edit-adhoc.component';
import { AdhocListComponent } from './components/adhoc/adhoc-list/adhoc-list.component';
import { ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { StoreStateModalComponent } from './components/common/store-state-modal/store-state-modal.component';
import { AddEditStoreCoverageComponent } from './components/storecoverage/add-edit-store-coverage/add-edit-store-coverage.component';
import { StoreCoverageListComponent } from './components/storecoverage/store-coverage-list/store-coverage-list.component';

@NgModule({
  declarations: [
    AddprojectComponent,
    AddEditSalesPlanComponent,
    GinfoKeyDatesComponent,
    GinfoObjectiveGoalsComponent,
    CommonStoreListComponent,
    GeneralInfoSalesplanDetailsComponent,
    GinfoKeyDatesComponent,
    GinfoObjectiveGoalsComponent,
    CommonStoreListComponent,
    GinfoProjectDetailsComponent,
    CommonProductsListComponent,
    GinfoSpKeyDatesComponent,
    CommonProductListManualComponent,
    ImageuploadComponent,
    ProjectCostEstimatesComponent,
    CommonApprovalComponent,
    FundingRmsComponent,
    InstructionsComponent,
    CurrencyFormatPipe,
    CheckIsValueEmptyPipePipe,
    GetApprovalStageColorPipe,
    AgencyQuestionsComponent,
    SreValidationCriteriaComponent,
    AddEditAdhocComponent,
    AdhocListComponent,
    StoreStateModalComponent,
    AddEditStoreCoverageComponent,
    StoreCoverageListComponent
  ],
  imports: [
    CommonModule,
    ProjectIntakeRoutingModule,
    MultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    DropdownModule,
    AutoCompleteModule,
    SharedModule,
    ConfirmDialogModule,
    NgxEditorModule,
    DialogModule,
    EditorModule,
    ToastModule,
    ConfirmPopupModule,
    ButtonModule,
    ToastModule,
    ConfirmPopupModule, 
  ],
  providers: [
    DatePipe,
    MessageService,
    ConfirmationService,
  ],
   exports: [
    ToastModule,
    ConfirmPopupModule,
    ButtonModule
  ],
})
export class ProjectIntakeModule { }
